import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useWebSocket, type WebSocketMessage } from '~/composables/useWebSocket';

export const useWebSocketStore = defineStore('websocket', () => {
  // 상태
  const isInitialized = ref(false);
  const lastMessage = ref<WebSocketMessage | null>(null);

  // WebSocket 컴포저블
  const { connect, disconnect, sendMessage, broadcastMessage, onMessage, isConnected, currentTabId } = useWebSocket();

  /**
   * WebSocket 초기화
   */
  const initialize = () => {
    if (isInitialized.value) {
      console.log('[WebSocketStore] 이미 초기화되어 있습니다.');
      return;
    }

    // 메시지 수신 시 lastMessage 업데이트
    onMessage((msgObj: WebSocketMessage) => {
      lastMessage.value = msgObj;
      console.log('[WebSocketStore] 메시지 수신:', msgObj.messageType);
    });

    // WebSocket 연결
    connect();

    isInitialized.value = true;
    console.log('[WebSocketStore] 초기화 완료');
  };

  /**
   * WebSocket 종료
   */
  const cleanup = () => {
    disconnect();
    isInitialized.value = false;
    console.log('[WebSocketStore] 정리 완료');
  };

  /**
   * 메시지 전송 헬퍼
   */
  const send = (data: Record<string, any>) => {
    sendMessage(data);
  };

  /**
   * 브로드캐스트 메시지 전송 헬퍼
   */
  const broadcast = (message: WebSocketMessage) => {
    broadcastMessage(message);
  };

  return {
    // 상태
    isInitialized,
    isConnected,
    lastMessage,
    currentTabId,

    // 액션
    initialize,
    cleanup,
    send,
    broadcast,
  };
});
